import React, { useEffect, useState } from "react";
import ChatWindow from "./ChatWindow";
import ChatMessageKit, { ChatMessageEnums } from "../../data/ChatMessageKit";
import ChatWindowView from "./ChatWindowView";
import { useCorporateChat } from "./hooks/useCorporateChat";

export default function CorporateChatWrapper({
  urlParams,
  me,
  corporateOrganization,
}) {
  const { corporateChatList } = useCorporateChat({
    urlParams,
    me,
    corporateOrganization,
  });

  return (
    <div className="d-flex">
      {corporateChatList &&
        Object.entries(corporateChatList).map((inbox) => {
          const [inboxUUID, data] = inbox;
          return (
            <ChatWindow {...data.props}>
              {(props) => <ChatWindowView {...props} />}
            </ChatWindow>
          );
        })}
    </div>
  );
}
